import React from 'react';

import { complement, isEmpty } from 'ramda';
import { useSelector } from 'react-redux';
import { GroupBase, OptionProps, components } from 'react-select-5';

import { IMasterProperty } from 'api/pages';
import Visibility from 'components/shared/Icon/icons/Visibility';
import { ContentIndicator } from 'components/shared/Select/components/ContentIndicator';
import { isAgentSelector } from 'store/user/selectors';
import { isDefined } from 'utils/ramda';

import s from './styles.module.css';

const isNotEmpty = complement(isEmpty);

type TProps<
  Option extends IMasterProperty = IMasterProperty,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = OptionProps<Option, IsMulti, Group> & {
  handlePreview: (option: Option) => Promise<void>;
};

export const PageOption = function <
  Option extends IMasterProperty = IMasterProperty,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: TProps<Option, IsMulti, Group>) {
  const { data, children, handlePreview } = props;

  const tags = data.tags;
  const isTagsVisisble = isDefined(tags) && isNotEmpty(tags);

  const handlePreviewClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    await handlePreview(data);
  };

  const isAgent = useSelector(isAgentSelector);
  const isIndicatorVisible = isAgent && (data.systemWide || data?.shared);

  return (
    <div className={s.wrapper}>
      <components.Option {...props}>
        <div className={s['option-container']}>
          <div className={s['option-content']}>
            <span className={s['option-label']}>{children}</span>
            {isTagsVisisble && <span className={s['option-info']}>Tag: {tags?.join(', ')}</span>}
          </div>

          <button type="button" onClick={handlePreviewClick} className={s['preview-btn']}>
            <Visibility />
          </button>
        </div>
      </components.Option>

      {isIndicatorVisible && <ContentIndicator isSharedPage={data?.shared} />}
    </div>
  );
};
